import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaItalian } from '../constants';
import { toast } from 'react-toastify';
import { transformRequestMunicipalityItalian } from 'system/geographic/utils/transformer-municipality-edit';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

const MunicipalityNewPage = (): React.ReactElement => {
  const insertMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/italiano`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityForm | undefined) => {
      const data = transformRequestMunicipalityItalian(formValues);
      (
        insertMunicipality({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [insertMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonMunicipalityCrumbs, { name: 'Nuovo Comune Italiano' }]} />
      <FormMunicipality
        title="Nuovo Comune Italiano"
        onOk={onSubmit}
        validationSchema={validationSchemaItalian}
        onCancel={() => {
          navigate('/sistema/geografiche/comune');
        }}
      />
    </Fragment>
  );
};

MunicipalityNewPage.displayName = 'Municipality new italian page component';

export default MunicipalityNewPage;
